import React, { Component } from 'react';
import utilities from '../../utils/utilities';
import categoriesApi from '../../api/Categories.api';
import entititiesApi from '../../api/Entities.api';
import xhr from '../../utils/xhr';
import NarrowByGroupedFilter from '../../pages/StartPage/Dashboard/components/FilterPod/NarrowByGrouped.filter';
import Spinner from '../../reusable/Spinner/Spinner';

export default class NarrowByFilterContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: null,
            entities: null
        }
    }

    componentDidMount() {
        categoriesApi
            .getCategoryNames()
            .then(categories => {
                this.setState({categories})
            })
            .catch((error) => {
                utilities.logError(error, 'Dashboard.filters.loadEntities(): ');
                xhr.handleAllErrors(error);
            });

        if (this.props.filtersState.filters.entities.entitiesId.length) {
            entititiesApi.specificNames(this.props.filtersState.filters.entities.entitiesId)
                .then(entities => {
                    this.setState({entities})
                })
                .catch((error) => {
                    utilities.logError(error, 'Dashboard.filters.loadEntities(): ');
                    xhr.handleAllErrors(error);
                });
        };
    }

    render() {
        const {...props} = this.props;
         return  <NarrowByGroupedFilter entities={this.state.entities} categories={this.state.categories} {...props} />
    }

}


// WEBPACK FOOTER //
// ./src/scripts/containers/Filters/NarowByFilterContainer.jsx